import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { TextField, 
    Grid, 
    Button, 
    Typography,
    FormControlLabel, 
    Switch,
    Box,
    CircularProgress
 } from '@material-ui/core';

import { addCategoria, getCategoria, editCategoria } from '../../store/actions/categoria';
import TituloPagina from '../../components/layout/TituloPagina';
import LoadingOverlay from '../../components/layout/LoadingOverlay';
import If from '../../components/condicional/if';
import normalizarTitulo from '../../assets/js/normalizarTitulo';

const CategoriaCadastro = props => {

    const history = useHistory();
    const location = useLocation();
    const { addCategoria, editCategoria, categoria, getCategoria, negocioDoUsuario, loading } = props;
    const [ disableFields, setDisableFields ] = React.useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [processingMessage, setProcessingMessage] = useState('');

    useEffect(() => {
        const id = Number(location?.state?.categoriaId);
        const isEditRoute = location.pathname === '/categorias/editar-categoria';

        if (isEditRoute && !id) {
            history.replace('/categorias');
            return;
        }

        if (id > 0) {
            getCategoria(id);
        }
    }, [getCategoria, history, location]);

    const validationSchema = yup.object({
        nome: yup.string()
            .required('Campo obrigatório')
            .max(30, 'Crie uma categoria com no máximo 30 caracteres'),
        prioridade: yup.number()
            .required('Informe um número que representa a ordem de prioridade da categoria')
            .typeError('Informe um número maior que zero'),
    });

    const formik = useFormik({
        initialValues: categoria.id > 0 ? {
            id: categoria.id,
            nome: categoria.nome,
            prioridade: categoria.prioridade,
            ativo: categoria.ativo,
        } : {
            nome: '',
            prioridade: '',
            ativo: false
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            setProcessingMessage('Salvando...');
            setIsProcessing(true);

            const nomeNormalizado = normalizarTitulo(values.nome);
            const newValues = { ...values, nome: nomeNormalizado, idNegocio: negocioDoUsuario };
            if (categoria.id > 0) {
                editCategoria(newValues);
            } else {
                addCategoria(newValues);
            }
            
            setDisableFields(true);
            setIsProcessing(false);
            setProcessingMessage('');
        },
        enableReinitialize: true,
    });

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Cadastro de Categorias' subtitulo={new Date().toLocaleString('pt-BR')} />
            <Grid container item xs={12} style={{ paddingTop: '15px' }}>
                <Grid container>
                    <Typography variant='body1' component='p'>
                        Em caso de mais de uma categoria com a mesma prioridade, o sistema adotará a ordem alfabética como segundo critério de ordenação.
                    </Typography>
                </Grid>
                <form onSubmit={formik.handleSubmit} noValidate autoComplete='off' style={{ width: 'inherit' }}>
                    <div style={{ flexGrow: 1, paddingTop: '15px' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id='nome'
                                    name='nome'
                                    label='Nome'
                                    variant='filled'
                                    disabled={disableFields}
                                    value={formik.values.nome}
                                    onChange={formik.handleChange}
                                    error={formik.touched.nome && Boolean(formik.errors.nome)}
                                    helperText={formik.touched.nome && formik.errors.nome} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    id='prioridade'
                                    name='prioridade'
                                    label='Prioridade'
                                    variant='filled'
                                    disabled={disableFields}
                                    value={formik.values.prioridade}
                                    onChange={formik.handleChange}
                                    error={formik.touched.prioridade && Boolean(formik.errors.prioridade)}
                                    helperText={formik.touched.prioridade && formik.errors.prioridade} />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Switch
                                        checked={formik.values.ativo}
                                        onChange={formik.handleChange}
                                        name="ativo"
                                        disabled={disableFields} />}
                                    label="Categoria Ativa"
                                />
                            </Grid>
                        </Grid>
                        <Grid container pt={4} style={{ paddingTop: '25px', paddingBottom: '25px' }}>
                            <If test={!disableFields}>
                                <Grid item style={{ paddingRight: '15px' }}>
                                    <Button type='submit' color='secondary' variant='contained'>Salvar</Button>
                                </Grid>
                                <Grid item style={{ paddingRight: '15px' }}>
                                    <Button variant='contained' href={`/categorias`}>Cancelar</Button>
                                </Grid>
                            </If>
                            <If test={disableFields}>
                                <Grid item style={{ paddingRight: '15px' }}>
                                    <Button color='secondary' variant='contained' href={`/categorias`}>Voltar</Button>
                                </Grid>
                            </If>
                        </Grid>
                    </div>
                </form>
            </Grid>

            {/* O componente Loading fica ouvindo o estado isProcessing */}
            <LoadingOverlay
                open={isProcessing}
                message={processingMessage}
            />
        </>
    )
}

const mapStateToProps = state => ({ 
    categoria: state.categoria.categoria,
    loading: state.categoria.loading,
    user: state.auth.user,
    negocioDoUsuario: state.negocio.negocioDoUsuario,
})
const mapDispatchToProps = dispatch => bindActionCreators({ addCategoria, getCategoria, editCategoria }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CategoriaCadastro)